var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 58 58",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "092---Payment-Alert",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m52 32c0 .33-.01.67-.02 1-.1409099 3.8841351-1.1597306 7.6859091-2.98 11.12-.307557.5931759-.6446464 1.1705666-1.01 1.73-2.0634976 3.2934742-4.8465258 6.0765024-8.14 8.14-.5594334.3653536-1.1368241.702443-1.73 1.01-3.4340909 1.8202694-7.2358649 2.8390901-11.12 2.98-.33.01-.67.02-1 .02s-.67-.01-1-.02c-3.8841351-.1409099-7.6859091-1.1597306-11.12-2.98-.59-.31-1.17-.64-1.73-1-3.29242361-2.0724252-6.07757475-4.8575764-8.15-8.15-.36-.56-.69-1.14-1-1.73-1.82026938-3.4340909-2.8390901-7.2358649-2.98-11.12-.01-.33-.02-.67-.02-1s.01-.67.02-1c.1409099-3.8841351 1.15973062-7.6859091 2.98-11.12.31-.6.64-1.17 1-1.73 2.06997165-3.2916898 4.8557713-6.0740713 8.15-8.14.5594334-.36535358 1.1368241-.70244298 1.73-1.01 3.4340909-1.82026938 7.2358649-2.8390901 11.12-2.98.33-.01.67-.02 1-.02s.67.01 1 .02c1.702053.06898772 3.3933551.30342564 5.05.7l19.23 19.23c.3965744 1.6566449.6310123 3.347947.7 5.05.01.33.02.67.02 1z",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m44.57 27.98c1.7831714 8.2373758-2.0733428 16.6649699-9.4726213 20.7004053s-16.5726736 2.7141229-22.5322902-3.2454938c-5.95961668-5.9596166-7.28092918-15.1330117-3.24549381-22.5322902 4.03543541-7.3992785 12.46302951-11.2557927 20.70040531-9.4726213z",
    fill: "#f0c419"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e57e25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m26 31c-2.209139 0-4-1.790861-4-4s1.790861-4 4-4 4 1.790861 4 4c0 .5522847.4477153 1 1 1s1-.4477153 1-1c-.0054296-2.9246159-2.1166966-5.4201335-5-5.91v-2.09c0-.5522847-.4477153-1-1-1s-1 .4477153-1 1v2.09c-3.0592195.5356138-5.2040646 3.3172488-4.9442104 6.4121125.2598542 3.0948638 2.8385088 5.4798993 5.9442104 5.4978875 2.209139 0 4 1.790861 4 4s-1.790861 4-4 4-4-1.790861-4-4c0-.5522847-.4477153-1-1-1s-1 .4477153-1 1c.0054296 2.9246159 2.1166966 5.4201335 5 5.91v2.09c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-2.09c3.0592195-.5356138 5.2040646-3.3172488 4.9442104-6.4121125-.2598542-3.0948638-2.8385088-5.4798993-5.9442104-5.4978875z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m27 6.02v2.98c0 .55228475-.4477153 1-1 1s-1-.44771525-1-1v-2.98c.33-.01.67-.02 1-.02s.67.01 1 .02z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m15 12.95c-.4811967.2705714-1.0904405.1060311-1.37-.37l-1.48-2.57c.5594334-.36535358 1.1368241-.70244298 1.73-1.01l1.49 2.58c.2723004.4809795.1074157 1.0914986-.37 1.37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m6.95 21c-.27955946.4760311-.88880334.6405714-1.37.37l-2.58-1.49c.31-.6.64-1.17 1-1.73l2.58 1.48c.47741568.2785014.64230039.8890205.37 1.37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m4 32c0 .5522847-.44771525 1-1 1h-2.98c-.01-.33-.02-.67-.02-1s.01-.67.02-1h2.98c.55228475 0 1 .4477153 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m6.58 44.37-2.58 1.48c-.36-.56-.69-1.14-1-1.73l2.58-1.49c.48048773-.2761424 1.09385763-.1104877 1.37.37s.11048773 1.0938576-.37 1.37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m15.37 52.42-1.49 2.58c-.59-.31-1.17-.64-1.73-1l1.48-2.58c.2761424-.4804877.8895123-.6461424 1.37-.37s.6461424.8895123.37 1.37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m27 55v2.98c-.33.01-.67.02-1 .02s-.67-.01-1-.02v-2.98c0-.5522847.4477153-1 1-1s1 .4477153 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m39.85 53.99c-.5594334.3653536-1.1368241.702443-1.73 1.01l-1.49-2.58c-.2761424-.4804877-.1104877-1.0938576.37-1.37s1.0938576-.1104877 1.37.37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m49 44.12c-.307557.5931759-.6446464 1.1705666-1.01 1.73l-2.57-1.48c-.3108211-.1786328-.5027321-.5095174-.5034421-.8680127s.1898889-.6901375.5-.87.692621-.1806201 1.0034421-.0019873z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m52 32c0 .33-.01.67-.02 1h-2.98c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1h2.98c.01.33.02.67.02 1z"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 44,
    cy: 14,
    fill: "#e64c3c",
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 44,
    cy: 22,
    fill: "#ecf0f1",
    r: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#ecf0f1",
    height: 12,
    rx: 2,
    width: 4,
    x: 42,
    y: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.a78cd0395739a0c21a056d194b5780b6.svg";
export { ForwardRef as ReactComponent };